import React, { useEffect, useState, useCallback } from "react";
import ButtonWithIcon from "../../Components/Reusable/ButtonWithIcon";
import { SvgImages } from "../../Utils/LocalImages";
import CustomDropDown from "../../Components/Reusable/CustomDropDown";
import { InputType, handleApiErrors, validationRegex } from "../../Utils/Utils";
import CustomTextField from "../../Components/Reusable/CustomTextField";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useLocation, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import RoutesPath from "../../Utils/RoutesPath";
import DataProvider from "../../Utils/DataProvider";
import CoordinatorService from "../../Services/CoordinatorService";
import StateService from "../../Services/StateService";
import PackagesService from "../../Services/PackagesService";
import CouponServices from "../../Services/CouponServices";
import { use } from "react";

const CreateCoupans = () => {
  const [couponList, setCouponList] = useState({ ...useLocation().state });
  const [applicablePackages, setApplicablePackages] = useState([]);
  const [discounttype, setDiscounttype] = useState([
    { label: "Percentage", value: "percentage" },
    { label: "Flat", value: "flat" },
  ]);
  const [userEligibility, setUserEligibility] = useState([
    { label: "New", value: "new" },
    { label: "Existing", value: "existing" },
    { label: "All", value: "all" },
  ]);
  const [selectedApplicablePackages, setSelectedApplicablePackages] = useState(
    []
  );

  const navigate = useNavigate();
  const Validations = yup.object().shape({
    couponcode: yup
      .string()
      .matches(
        /^[A-Za-z0-9]{5,15}$/,
        "Coupon code must be 5-15 alphanumeric characters"
      )
      .required(),
    // discription: validationRegex.required,
    discounttype: validationRegex.required,
    discountvalue: validationRegex.required,
    // maxvalue: validationRegex.required,
    // orderpuchaselvalue: validationRegex.required,
    // applicablepackages: validationRegex.required,
    // applicablepackages: yup
    //   .array()
    //   .nullable()
    //   .min(1, "At least one package must be selected"),
    // nooftimesuse: validationRegex.required,
    // useperuser: validationRegex.required,
    // usereligibility: validationRegex.required,
    // startdate: validationRegex.required,
    // enddate: validationRegex.required,

    startdate: yup
      .date()
      .typeError("Please select a valid date")
      .required("Start date is required")
      .min(
        new Date(new Date().setHours(0, 0, 0, 0)), // Current date with time set to 00:00:00
        "Start date cannot be in the past"
      ),
    enddate: yup
      .date()
      .typeError("Please select a valid date")
      .required("End date is required")
      .min(
        new Date(new Date().setHours(0, 0, 0, 0)), // Current date with time set to 00:00:00
        "End date cannot be in the past"
      ),
  });
  const {
    register: register,
    handleSubmit: handleSubmit,
    setValue: setValues,
    watch: watchdetails,
    formState: { errors: errors },
    getValues: getValues,
  } = useForm({
    resolver: yupResolver(Validations),
    defaultValues: {
      couponcode: couponList?.couponCode || "",
      discription: couponList?.description || "",
      discounttype: couponList?.discountType || "",
      discountvalue: couponList?.discountValue || "",
      maxvalue: couponList?.maxValue || "",
      orderpuchaselvalue: couponList?.minOrderPurchaseValue || "",
      applicablepackages: couponList?.applicablePackages || "",
      nooftimesuse: couponList?.usageLimit || "",
      useperuser: couponList?.maxUsageLimitPerUser || "",
      usereligibility: couponList?.userEligibility || "",
      startdate: couponList?.validity?.startDate || "",
      enddate: couponList?.validity?.endDate || "",
    },
  });
  const getAppicablePackagesWithoutPagination = async () => {
    try {
      const response =
        await CouponServices.getAppicablePackagesWithoutPagination();
      setApplicablePackages(response.data);
    } catch (error) {
      handleApiErrors(error);
    }
  };
  const onSubmit = async (couponData) => {
    if (
      couponData.nooftimesuse < 0 ||
      couponData.useperuser < 0 ||
      couponData.discountvalue < 0 ||
      couponData.maxvalue < 0 ||
      couponData.orderpuchaselvalue < 0
    ) {
      return toast.error("Negative values are not allowed");
    }
    if (couponData.nooftimesuse && couponData.nooftimesuse >= 0) {
      console.log(couponData.nooftimesuse, couponData.useperuser);
      if (couponData.nooftimesuse < couponData.useperuser) {
        return toast.error(
          "No of times used should be greater than max usage per user"
        );
      }
    }
    if (
      couponData.discounttype == "percentage" &&
      couponData.discountvalue > 100
    ) {
      return toast.error("Discount value should be less than or equal to 100%");
    }

    const validity = {
      startDate: couponData.startdate,
      endDate: couponData.enddate,
    };
    const applicablePackagesIds =
      selectedApplicablePackages.length > 0
        ? selectedApplicablePackages.map((pkg) => pkg.value) // If user selects packages, use them
        : couponData.applicablepackages === undefined ||
          couponData.applicablepackages.length === 0
        ? [] // If the user sends an empty array, keep it empty
        : couponList.applicablePackages
        ? couponList.applicablePackages.map((pkg) => pkg.packageId) // Otherwise, use default couponList packages
        : [];

    // console.log(couponData, "couponData");
    // console.log(applicablePackagesIds, "applicablePackagesIds");
    // console.log(validity, "validity");

    try {
      const response = await CouponServices.addCoupon(
        couponList?.couponId || "",
        couponData.couponcode.toUpperCase(),
        couponData.discription,
        couponData.discounttype,
        couponData.discountvalue,
        couponData.maxvalue,
        couponData.orderpuchaselvalue,
        // couponData.applicablepackages,
        applicablePackagesIds,
        couponData.nooftimesuse,
        couponData.useperuser,
        couponData.usereligibility == "" ? "all" : couponData.usereligibility,
        validity
      );
      toast.success(response.message);
      navigate(RoutesPath.coupanlisting);
      setCouponList({});
    } catch (error) {
      // Handle API errors
      handleApiErrors(error);
      toast.error("Failed to add coupon. Please try again later.");
    }
  };

  useEffect(() => {
    getAppicablePackagesWithoutPagination();
  }, [couponList]);

  useEffect(() => {
    console.log(couponList, "couponList");
    const startDate = new Date(couponList?.validity?.startDate);
    const endDate = new Date(couponList?.validity?.endDate);
    setValues("startdate", startDate.toLocaleDateString("sv-SE"));
    setValues("enddate", endDate.toLocaleDateString("sv-SE"));
  }, [couponList, setValues, selectedApplicablePackages]);

  return (
    <div>
      <div className="mb-3 d-flex justify-content-between">
        <h1 className="black fs-18 fw-600 mb-0">Coupon Code</h1>
        <div className="d-flex">
          <h4 className="fs-12 fw-500 black mb-0 me-1">Dashboard &gt;</h4>
          <h4 className="fs-12 fw-500 primary mb-0">Coupon Code</h4>
        </div>
      </div>
      <div className="table_container" style={{ display: "block" }}>
        <div className="table_title ps-2">
          <div className="table_headings">
            <h1 className="black fs-18 fw-600 mb-0">
              {couponList.couponId ? "Edit Coupon Code" : "Add Coupon Code"}
            </h1>
          </div>

          <form className="" onSubmit={handleSubmit(onSubmit)}>
            <div className="row profile_inputs w-100 mt-4">
              <div className="col-md-6">
                <CustomTextField
                  labelTitle="Coupon Code"
                  placeholder="Coupon Code"
                  name="couponcode"
                  id="couponcode"
                  additionalClasses="profile_edit"
                  inputType={InputType.text}
                  showMandatory={true}
                  register={register}
                  showError={errors.couponcode}
                  errorMessage={errors?.couponcode?.message}
                  style={{ textTransform: "uppercase" }}
                />
              </div>
              <div className="col-md-6">
                <CustomTextField
                  labelTitle="Description"
                  placeholder="Description"
                  name="discription"
                  id="discription"
                  additionalClasses="profile_edit"
                  inputType={InputType.text}
                  // showMandatory={true}
                  register={register}
                  showError={errors?.discription}
                  errorMessage={errors?.discription?.message}
                />
              </div>
              <div className="col-md-6">
                {/* {classes && classes.length != 0 && ( */}
                <CustomDropDown
                  labelTitle="Discount Type"
                  placeholder="Select"
                  name="discounttype"
                  id="discounttype"
                  additionalClasses="profile_edit"
                  inputType={InputType.text}
                  showError={errors?.discounttype}
                  errorMessage={errors?.discounttype?.message}
                  showMandatory={true}
                  setValue={setValues}
                  options={discounttype}
                  defaultOption={() => {
                    return couponList.discountType
                      ? {
                          value: couponList.discountType,
                          label: couponList.discountType,
                        }
                      : null;
                  }}
                />
                {/* )} */}
              </div>

              <div className="col-md-6">
                <CustomTextField
                  labelTitle="Discount Value"
                  placeholder="Discount Value"
                  name="discountvalue"
                  id="discountvalue"
                  additionalClasses="profile_edit"
                  inputType={InputType.number}
                  showMandatory={true}
                  register={register}
                  showError={errors?.discountvalue}
                  errorMessage={errors?.discountvalue?.message}
                />
              </div>
              <div className="col-md-6">
                <CustomTextField
                  labelTitle="Max Value"
                  placeholder="Max Value"
                  name="maxvalue"
                  id="maxvalue"
                  additionalClasses="profile_edit"
                  inputType={InputType.number}
                  // showMandatory={true}
                  register={register}
                  showError={errors?.maxvalue}
                  errorMessage={errors?.maxvalue?.message}
                />
              </div>
              <div className="col-md-6">
                <CustomTextField
                  labelTitle="Min. Order Purchase Value"
                  placeholder="Min. Order Purchase Value"
                  name="orderpuchaselvalue"
                  id="orderpuchaselvalue"
                  additionalClasses="profile_edit"
                  inputType={InputType.number}
                  // showMandatory={true}
                  register={register}
                  showError={errors?.orderpuchaselvalue}
                  errorMessage={errors?.orderpuchaselvalue?.message}
                />
              </div>

              <div className="col-md-6">
                <CustomDropDown
                  labelTitle="Applicable Packages"
                  placeholder="Select"
                  name="applicablepackages"
                  id="applicablepackages"
                  additionalClasses="profile_edit"
                  inputType={InputType.select} // Changed to select for multiple options
                  showError={errors?.applicablepackages}
                  errorMessage={errors?.applicablepackages?.message}
                  // showMandatory={true}
                  setValue={setValues}
                  onChange={(selectedOptions) => {
                    setSelectedApplicablePackages(selectedOptions);
                  }}
                  options={applicablePackages?.map((e) => {
                    return { value: e.package_id, label: e.packageName };
                  })}
                  isMulti={true}
                  defaultOption={() => {
                    return couponList.applicablePackages
                      ? couponList.applicablePackages.map((pkg) => ({
                          value: pkg.packageId,
                          label: pkg.packageName,
                        }))
                      : null;
                  }}
                />
              </div>

              <div className="col-md-6">
                <CustomTextField
                  labelTitle="Usage Limit/No. of times Use"
                  placeholder="Usage Limit/No. of times Use"
                  name="nooftimesuse"
                  id="nooftimesuse"
                  additionalClasses="profile_edit"
                  inputType={InputType.number}
                  // showMandatory={true}
                  register={register}
                  showError={errors?.nooftimesuse}
                  errorMessage={errors?.nooftimesuse?.message}
                  defaultValues={couponList.usageLimit}
                />
              </div>
              <div className="col-md-6">
                <CustomTextField
                  labelTitle="Max Uses Per User"
                  placeholder="Max Uses Per User"
                  name="useperuser"
                  id="useperuser"
                  additionalClasses="profile_edit"
                  inputType={InputType.number}
                  // showMandatory={true}
                  register={register}
                  // showError={errors?.useperuser}
                  errorMessage={errors?.useperuser?.message}
                  defaultValues={couponList.maxUsageLimitPerUser}
                />
              </div>
              <div className="col-md-6">
                {/* {classes && classes.length != 0 && ( */}
                <CustomDropDown
                  labelTitle="User Eligibility"
                  placeholder="Select"
                  name="usereligibility"
                  id="usereligibility"
                  additionalClasses="profile_edit"
                  inputType={InputType.text}
                  showError={errors?.usereligibility}
                  errorMessage={errors?.usereligibility?.message}
                  // showMandatory={true}
                  setValue={setValues}
                  options={userEligibility}
                  defaultOption={() => {
                    return couponList.userEligibility
                      ? {
                          value: couponList.userEligibility,
                          label: couponList.userEligibility,
                        }
                      : null;
                  }}
                />
                {/* )} */}
              </div>

              <div className="col-md-6">
                <CustomTextField
                  labelTitle="Start Date"
                  id="startdate"
                  name="startdate"
                  showError={errors?.startdate}
                  errorMessage={errors?.startdate?.message}
                  register={register}
                  additionalClasses="profile_edit"
                  inputType="date"
                  showMandatory={true}
                />
              </div>
              <div className="col-md-6">
                <CustomTextField
                  labelTitle="End Date"
                  id="enddate"
                  name="enddate"
                  showError={errors?.enddate}
                  errorMessage={errors?.enddate?.message}
                  register={register}
                  additionalClasses="profile_edit"
                  inputType="date"
                  showMandatory={true}
                />
              </div>

              <div className="d-flex justify-content-end mt-3">
                <ButtonWithIcon
                  text={couponList?.couponId ? "Update" : "Submit"}
                  icon={SvgImages.tick_mark}
                  onClick={handleSubmit(onSubmit)}
                />
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default CreateCoupans;
